// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Vpod","tabsBox":"styles_tabsBox__3x3CW","createButton":"styles_createButton__3pEU6"};